import React from 'react';
import { BlogPostTemplate } from '../components/Blog/BlogPostTemplate';
import blogData from '../data/blog/en/7-signs-of-gaslighting.json';
import { BlogPostData } from '../types/blog';
export function BlogPost7SignsGaslighting() {
  return <BlogPostTemplate content={blogData as BlogPostData} data-id="element-3920" />;
}